import superagent from 'superagent';
import { routes } from './routerHelper';

const BASE_PATH = 'https://www.coolcampuschallenge.org/v1';

const promisifySuperAgentRequest = superAgentRequest => new Promise((resolve, reject) => {
  superAgentRequest.end((err, res) => {
    if (err) reject(err);
    else {
      resolve(res);
    }
  });
});

export const errEmailNonUnique = 'errEmailNonUnique';
export const errPasswordIncorrect = 'errPasswordIncorrect';
export const errEmailNotFound = 'errEmailNotFound';
export const errInvalidImageType = 'errInvalidImageType';
export const errFileSizeTooBig = 'errFileSizeTooBig';

export const login = payload => promisifySuperAgentRequest(
  superagent.post(`${BASE_PATH}/session`)
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .send(JSON.stringify(payload)),
);

export const signup = payload => promisifySuperAgentRequest(
  superagent.post(`${BASE_PATH}/users`)
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .send(JSON.stringify(payload)),
);

export const updateUser = (payload, token) => promisifySuperAgentRequest(
  superagent.put(`${BASE_PATH}/users/${payload.user.id}`)
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .set('Authorization', token)
    .send(JSON.stringify(payload)),
);

export const deleteUser = (user, token) => promisifySuperAgentRequest(
  superagent.delete(`${BASE_PATH}/users/${user.id}`)
    .set('Authorization', token),
);

export const logout = token => promisifySuperAgentRequest(
  superagent.delete(`${BASE_PATH}/session`)
    .set('Authorization', token),
);

export const updateCalculatorAnswers = (user, payload, token) => promisifySuperAgentRequest(
  superagent.put(`${BASE_PATH}/calculator_answers/${user.id}`)
    .set('Authorization', token)
    .set('Content-Type', 'application/json')
    .send(payload),
);

export const me = (token, query) => promisifySuperAgentRequest(
  superagent.get(`${BASE_PATH}/me`)
    .set('Authorization', token)
    .set('Accept', 'application/json')
    .query(query),
);

export const getCalculatorAnswers = (user, token) => promisifySuperAgentRequest(
  superagent.get(`${BASE_PATH}/calculator_answers/${user.id}`)
    .set('Authorization', token)
    .set('Accept', 'application/json'),
);

export const defaultCalculatorResultLeadersLimit = 50;

export const getCalculatorResultLeaders = query => promisifySuperAgentRequest(
  superagent.get(`${BASE_PATH}/calculator_result_leaders`)
    .set('Accept', 'application/json')
    .query(query),
);

export const postImage = (file, token) => {
  const formData = new FormData();
  formData.append('image', file);
  return promisifySuperAgentRequest(
    superagent.post(`${BASE_PATH}/image`)
      .set('Authorization', token)
      .set('Accept', 'application/json')
      // Leave 'Content-Type' undefined so browser can define form boudary.
      .send(formData),
  );
};

export const userPledgeStatus = {
  COMPLETED: '3',
  PLEDGED: '2',
  NOT_RELEVANT: '1',
};

export const getUserPledges = userId => promisifySuperAgentRequest(
  superagent.get(`${BASE_PATH}/users/${userId}/pledges`)
    .set('Accept', 'appliication/json')
    .query({ userPledgeDomain: 'calculator' }),
);

export const leadersOrder = {
  GRAND_TOTAL: 'result_grand_total',
  TRANSPORT: 'result_transport_total',
  HOUSING: 'result_housing_total',
  FOOD: 'result_food_total',
};

export const getCalculatorRouteLeadersOrder = (route) => {
  switch (route) {
    case routes.TRAVEL:
      return leadersOrder.TRANSPORT;
    case routes.FOOD:
      return leadersOrder.FOOD;
    case routes.HOME:
      return leadersOrder.HOUSING;
    default:
      return leadersOrder.GRAND_TOTAL;
  }
};
